import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppLight from './AppLight';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppLight />
  </React.StrictMode>
); 